export default {
  cakeCustomize: {
    photocakeImg: '',
    photocakeUploads: [],
    previewCakeImg: '',
    staticPreviewImg: '',
  },
};
